"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorityTransport = exports.AuthorityInput = exports.Applications = void 0;
const typebox_1 = require("@sinclair/typebox");
const wayste_account_info_transport_1 = require("./wayste-account-info-transport");
exports.Applications = typebox_1.Type.Union([
    typebox_1.Type.Literal('wayste'),
    typebox_1.Type.Literal('aap'),
    typebox_1.Type.Literal('customer-portal'),
    typebox_1.Type.Literal('wayste-dashboard'),
]);
exports.AuthorityInput = typebox_1.Type.Object({
    active: typebox_1.Type.Boolean(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    contactID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    applicationName: typebox_1.Type.String(),
    roles: typebox_1.Type.Array(typebox_1.Type.String()),
});
exports.AuthorityTransport = typebox_1.Type.Object({
    profileID: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    contactID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    application: exports.Applications,
    roles: typebox_1.Type.Array(typebox_1.Type.String()),
    waysteAccountInfo: typebox_1.Type.Optional(wayste_account_info_transport_1.WaysteAccountInfoTransport),
    token: typebox_1.Type.String(),
});
//# sourceMappingURL=authority-transport.js.map